import { products as staticProducts } from "../data/products";
import { useProducts } from "../context/ProductsContext";
import { ProductCard } from "./ProductCard";

export const Products = () => {
  const { products } = useProducts();
  const list = products.length > 0 ? products : staticProducts;
  return (
    <section
      id="produse"
      data-testid="products-section"
      className="pt-2 md:pt-10 pb-20 md:pb-28 relative"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/3 -left-32 w-96 h-96 rounded-full bg-cyan-200/30 blur-3xl" />
        <div className="absolute bottom-0 -right-32 w-96 h-96 rounded-full bg-teal-200/30 blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 md:px-10">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {list.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      </div>
    </section>
  );
};
